import { render, staticRenderFns } from "./ExtratoFaturaPacote.vue?vue&type=template&id=38a295b0&scoped=true&"
import script from "./ExtratoFaturaPacote.vue?vue&type=script&lang=js&"
export * from "./ExtratoFaturaPacote.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoFaturaPacote.vue?vue&type=style&index=0&id=38a295b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a295b0",
  null
  
)

export default component.exports